import { setLoadingConfigObject } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './ExtraLoadingScreen.styles';

const titleLoadingConfig = [
  {
    main: setLoadingConfigObject('line', 1, '45%', styles.lineStyle),
  },
];
const tabLoadingConfig = theme => [
  {
    main: setLoadingConfigObject('square', 1, null, styles.tabContentStyle(theme)),
    style: styles.tabContainerStyle(theme),
  },
];
const optionTitleLoadingConfig = [
  {
    main: setLoadingConfigObject('line', 1, '45%', styles.lineStyle),
  },
];
const optionsLoadingConfig = theme => [
  {
    main: [
      'column',
      setLoadingConfigObject('square', 1, null, styles.optionContentStyle(65, theme)),
      setLoadingConfigObject('square', 1, null, styles.optionContentStyle(52, theme)),
    ],
    style: styles.optionContainerStyle(theme),
  },
];
const footerLoadingConfig = theme => [
  {
    left: setLoadingConfigObject('square', 1, null, styles.footerFirstSectionLeftLineStyle),
    right: setLoadingConfigObject('square', 1, null, styles.footerFirstSectionRightLineStyle),
    style: styles.footerFirstSectionStyle,
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.footerSecondSectionSquareStyle),
    main: [
      setLoadingConfigObject('line', 1, '97%', styles.footerSecondSectionMainFirstLineStyle),
      setLoadingConfigObject('line', 1, '31%', styles.footerSecondSectionMainSecondLineStyle),
    ],
    right: setLoadingConfigObject('square', 1, null, styles.footerSecondSectionRightLineStyle),

    style: styles.footerSecondSectionStyle(theme),
  },
  {
    main: setLoadingConfigObject('line', 1, '100%', styles.divider),
  },
  {
    main: setLoadingConfigObject('line', 2, '100%', styles.bottomLineStyle),
  },
  {
    main: setLoadingConfigObject('line', 1, '82%', styles.bottomLineStyle),
  },
  {
    main: setLoadingConfigObject('square', 2, null, styles.footerThirdSectionSquareStyle),
  },
];

export {
  titleLoadingConfig,
  tabLoadingConfig,
  optionTitleLoadingConfig,
  optionsLoadingConfig,
  footerLoadingConfig,
};
